import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../../../app/core/service/auth.service';
import { environment } from '../../../environments/environment';
import { AlertsService } from '../../../app/shared/service/alerts.service';
import { SocketService } from '../../../app/shared/service/socket.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.scss']
})
export class NavComponent implements OnInit 
{

  token;
  comments = [];
  newcomment = 0;
  form:UntypedFormGroup;
  sub1: Subscription;

  constructor(private socket: SocketService,private alert: AlertsService,private api: AuthService,private router: Router) { }

  ngOnInit(): void 
  {
    if(localStorage.getItem(environment.tokenKey))
    {
      this.token = JSON.parse(atob((localStorage.getItem(environment.tokenKey)).split('.')[1])).token
    }
    this.createForm();
  }

  createForm()
  {
    this.form = new UntypedFormGroup(
    {
      oldPassword :  new UntypedFormControl("",Validators.required),
      newPassword :  new UntypedFormControl("",Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,}$)/)),
    });

    this.alert.detectFormChanges(this.form);
  }

  
  changePassword() 
  {

    var obj =
    {
      old: this.form.value.oldPassword,
      password: this.form.value.newPassword
    }

    this.api.changePassword(obj).subscribe((res:any) =>
    {
      const { success, data, message } = res
      if (success)
      {
        this.alert.showToast(message,"success" )
        this.logout()
      }
      else
      {
        this.alert.showToast(message,"error")
      }
    },(err)=> this.alert.showToast(err.message,"error" ))
  }

  logout()
  {
    this.socket.logout(this.token._id)
    this.api.logout();
  }

  ngOnDestroy(): void
  {

    if (this.sub1)
    {
      this.sub1.unsubscribe();
    }
  }

}
